import { createSlice } from "@reduxjs/toolkit";
import { InsuranceDetails } from "./types";

const initialState: InsuranceDetails = {
  platform: null,
  tracker_id: null,
  user_id: null,
  is_user_logged_in: null,
  customer_name: null,
  user_phone_number_login: null,
  user_phone_number_journey: null,
  user_pincode_journey: null,
  user_email_journey: null,
  registration_number: null,
  rto_zone: null,
  vehicle_make: null,
  vehicle_model: null,
  vehicle_variant: null,
  make_id: null,
  model_id: null,
  variant_id: null,
  registration_date: null,
  registration_month: null,
  registration_year: null,
  fuel_type: null,
  engine_cc: null,
  chassis_number: null,
  engine_number: null,
  external_cng_kit: null,
  is_commercial: null,
  previous_policy_type: null,
  previous_policy_expiry_date: null,
  previous_policy_expiry_bucket: null,
  previous_insurer: null,
  previous_od_expiry_date: null,
  previous_tp_expiry_date: null,
  previous_idv: null,
  previous_ncb: null,
  last_year_claim_flag: null,
  current_ncb: null,
  url: null,
  landing_url: null,
  utm_source: null,
  utm_medium: null,
  utm_campaign: null,
  utm_content: null,
  utm_term: null,
  user_agent: null,
  plans_offered: null,
  add_ons_offered: null,
  add_on_offered_count: null,
  recommended_idv: null,
  min_idv: null,
  max_idv: null,
  is_inspection_reqd: null,
  discounts_offered: null,
  discounts_applied: null,
  total_discount_amount_applied: null,
  max_discount_amount_eligible: null,
  discount_applied: null,
  discount_amount: null,
  plan_selected: null,
  idv_selected: null,
  add_ons_selected: null,
  add_ons_selected_count: null,
  gross_coverage_premium: null,
  net_coverage_premium: null,
  is_make_autofilled: null,
  is_model_autofilled: null,
  is_variant_autofilled: null,
  is_engine_number_autofilled: null,
  is_chassis_number_autofilled: null,
  is_registration_date_autofilled: null,
  is_previous_policy_type_autofilled: null,
  is_previous_policy_expiry_date_autofilled: null,
  is_previous_insurer_autofilled: null,
  is_previous_idv_autofilled: null,
  is_previous_ncb_autofilled: null,
  is_last_year_claim_flag_autofilled: null,
  is_last_claim_year_autofilled: null,
  is_phone_number_autofilled: null,
  is_pincode_autofilled: null,
  is_rc_name_autofilled: null,
  view_type: null,
  view_name: null,
  action_type: null,
  action_name: null,
  journey_name: null,
  current_primary_covers: null,
  current_additional_covers: null,
  lastyear_renewal_premium_delta: null,
  renewal_price_delta_bucket: null,
  asset_age: null,
  previous_plan: null,
  previous_primary_covers: null,
  previous_additional_covers: null,
  previous_addons_count: null,
  current_idv: null,
  lastyear_renewal_ncb_delta: null,
  experiments: null,
  premium_delta: null,
  gross_premium_difference: null,
  make_name: null,
  model_name: null,
  variant_name: null,
  user_name: null,
  booking_status: null,
  dealership_name: null,
  dealership_id: null,
  transmission_type: null,
  experiment_context: null
};

const AnalyticsSlice = createSlice({
  name: "analytics",
  initialState,
  reducers: {
    setAnalyticsData(state, action) {
      return { ...state, ...action.payload };
    },
    resetAnalyticsState() {
      return { ...initialState };
    }
  }
});

export const { setAnalyticsData, resetAnalyticsState } = AnalyticsSlice.actions;
export default AnalyticsSlice.reducer;
